import React from 'react';
import { connect } from 'react-redux';

import { i18n } from 'app/i18n';
import { Container } from 'app/components/common/container';
import { Paper } from 'app/components/common/paper';
import { RootState } from 'app/redux/state/root-state';
import { Order } from 'app/page/orders/summary/order';
import { PendingActionUtils } from 'app/page/orders/utils/pending-action-utils';
import { PendingAction } from 'app/page/orders/redux/model/pending-action';
import { PendingType } from 'app/page/orders/redux/model/pending-type';
import { BillingAccount } from 'app/page/orders/model/billing-account';
import { BillingAccountUtils } from 'app/page/orders/utils/billing-account-utils';
import { AccountSwitchLink, AddressSwitchLink } from 'app/components/domain/switch-link';
import { Typography } from 'app/components/domain/typography';

import { SummaryPlaceholder } from './summary-placeholder';

import styles from './summary.module.scss';

interface Props {
    initialized: boolean;
    billingAccounts: BillingAccount[];
    selectedBillingAccountId?: string;
    pendingActions: PendingAction[];
}

class SummaryComponent extends React.Component<Props> {
    public render(): React.ReactNode {
        const { initialized, billingAccounts, selectedBillingAccountId, pendingActions } = this.props;

        const showPlaceholders: boolean =
            !initialized ||
            PendingActionUtils.isActionPending(
                pendingActions,
                PendingType.LOAD_BILLING_ACCOUNTS,
                PendingType.LOAD_INFLIGHT_ORDERS,
            ) ||
            !selectedBillingAccountId ||
            !BillingAccountUtils.getBillingAccount(billingAccounts, selectedBillingAccountId).selectedOrderId ||
            PendingActionUtils.isActionWithIdPending(pendingActions, {
                type: PendingType.LOAD_CUSTOMER_INFORMATION,
                id: selectedBillingAccountId,
            });

        return (
            <div className={styles.summary}>
                <Container>
                    <Paper>
                        <Typography className={styles.title} variant="heading" component="h1">
                            {i18n.summary.title}
                        </Typography>
                        <div className={styles.switchLinksContainer}>
                            <AccountSwitchLink />
                            <AddressSwitchLink />
                        </div>
                        {showPlaceholders ? <SummaryPlaceholder /> : <Order />}
                    </Paper>
                </Container>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState): Props => {
    const {
        orders: { initialized, billingAccounts, selectedBillingAccountId, pendingActions },
    } = state;

    return {
        initialized,
        billingAccounts,
        selectedBillingAccountId,
        pendingActions,
    };
};

const Summary = connect(mapStateToProps)(SummaryComponent);

export { Summary };
